module.exports = __webpack_public_path__ + "static/media/hamburger-icon-white.f1f17279.svg";